// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PizCS","fullView":"styles_fullView__1bwzS"};